import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getElementCenterPos, Grid, ModuleFE_MouseInteractivity, ModuleFE_Thunderstorm, mouseInteractivity_ToolTip } from '@nu-art/thunderstorm-frontend';
import './Tooltip_UserPromptLegend.scss';
const userPromptParams = [
    { key: 'age', description: 'Patient age as text, or "unknown"' },
    { key: 'gender', description: 'Patient gender as value label (for example "female"), or "unknown"' },
    { key: 'hpi_text', description: 'Latest HPI textual finding value, or empty' },
    { key: 'ed_course_text', description: 'Latest ED Course textual finding value, or empty' },
    {
        key: 'covered_protocols',
        description: 'A comma-separated list of protocol names already documented in the note',
        prerequisite: 'The note must resolve with a param of sub-type MDM'
    }
];
const Component = () => {
    return _jsxs(_Fragment, { children: [_jsxs(Grid, { className: 'user-prompt-param header', children: [_jsx("div", { className: 'user-prompt-param__key', children: "Key" }), _jsx("div", { className: 'user-prompt-param__description', children: "Description" }), _jsx("div", { className: 'user-prompt-param__prerequisite', children: "Prerequisite" })] }), userPromptParams.map(param => {
                return _jsxs(Grid, { className: 'user-prompt-param', children: [_jsx("div", { className: 'user-prompt-param__key', onClick: () => ModuleFE_Thunderstorm.copyToClipboard(`{${param.key}}`), children: '{' + param.key + '}' }), _jsx("div", { className: 'user-prompt-param__description', children: param.description }), _jsx("div", { className: 'user-prompt-param__prerequisite', children: param.prerequisite ?? 'None' })] }, param.key);
            })] });
};
export const Tooltip_UserPromptLegend = {
    onMouseEnter: (e) => {
        const model = {
            id: 'user-prompt-legend',
            modalPos: { x: -1, y: 1 },
            originPos: getElementCenterPos(e.currentTarget),
            contentHoverDelay: 300,
            offset: { x: -8, y: 8 },
            content: () => _jsx(Component, {}),
        };
        ModuleFE_MouseInteractivity.showTooltip(model);
    },
    onMouseLeave: (e) => {
        ModuleFE_MouseInteractivity.hide(mouseInteractivity_ToolTip);
    },
};
//# sourceMappingURL=Tooltip_UserPromptLegend.js.map